<template>
<div class="lesson-item">
    <div class="lesson-group">
        <lessonGroup/>
    </div>
</div>
</template>

<script>
import lessonGroup from '@/views/lesson/group/list'
export default {
    components: {
        lessonGroup
    }
}
</script>

<style lang="less">
.lesson-group {
    .lesson-group-list {
        .container {
            width: 100%;
        }
    }
}
</style>
